const SvgLoader: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Spinner">
      <path
        id="Oval"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM21.176 12C21.176 6.93193 17.0675 2.82349 11.9995 2.82349C6.93149 2.82349 2.82305 6.93193 2.82305 12C2.82305 17.068 6.93149 21.1764 11.9995 21.1764C17.0675 21.1764 21.176 17.068 21.176 12Z"
        fill="#ededed"
        fillOpacity="0.9"
      />
      <path
        id="Path"
        d="M12.1893 0C18.7121 0 23.9998 5.28775 23.9998 11.8105C23.9998 12.5779 23.3777 13.2 22.6103 13.2C21.8429 13.2 21.2209 12.5779 21.2209 11.8105C21.2209 6.82252 17.1773 2.77895 12.1893 2.77895C11.4219 2.77895 10.7998 2.15686 10.7998 1.38947C10.7998 0.622088 11.4219 0 12.1893 0Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default SvgLoader;
